// app/javascript/services/vue_root.js
//
// Every pack mounts Vue on the server-rendered `[data-behavior="vue"]` element,
// so Vue compiles that HTML as a template. ERB escapes `<`, `>` and quotes but
// not braces, so any user text containing `{{ ... }}` would run as an
// expression in the viewer's session.
//
// These delimiters switch root-level text interpolation off. The HTML parser
// discards or replaces NUL characters (dropped from body text, U+FFFD
// elsewhere; `&#0;` decodes to U+FFFD), so server-rendered text can never
// contain the delimiter. Views have no root-level `{{ }}` of their own, and
// .vue components are precompiled with their own delimiters, so neither is
// affected.
//
// This protects only text in the server-rendered root template. Directive
// attributes (`:prop=`, `v-*`, `@event`) are still compiled as expressions,
// so a view must never put user input inside one.
export const ROOT_DELIMITERS = ['\u0000', '\u0000']
